import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/hooks';
import { getVisibleSettingsTabs } from './tabs';

export default function SettingsPage() {
    const profile = useAppSelector(store => store.profile);
    const navigate = useNavigate();

    useEffect(() => {
        const availableTab = getVisibleSettingsTabs(profile)[0];
        if (availableTab) {
            navigate(availableTab.route, { replace: true });
        }
    }, [profile, navigate]);

    return <></>;{/*This form cannot be deleted. This intermediate form is needed to ensure that the breadcrumbs display correctly.*/}
}
